import Image from 'next/image';
import { useEffect, useMemo, useState } from 'react'

import styles from './styles.module.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmarkCircle, faCheck, faChevronDown, faClipboardCheck, faTrashCan, faUpload, faXmark, faChevronLeft, faMapLocationDot, faCheckCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import categoryName from '../../../../Functions/categoryName'

import { isEqual } from 'lodash';

import { Reorder } from 'framer-motion';

import NumberFormat from 'react-number-format';
import { PulseLoader } from 'react-spinners';
import GridDragAndDrop from '../../../../Misc/GridDragAndDrop/GridDragAndDrop';

import MapWithRadius from '../../../../Misc/MapWithRadius/MapWithRadius';

import { useSession } from 'next-auth/react'

import Resizer from 'react-image-file-resizer'

import errorMsg from '../../../../Functions/errorMsg';
import successMsg from '../../../../Functions/successMsg';

import axios from 'axios';

import PolicyPage from '../../../../Home/Policies/Policies';

import MapWithLocation from '../../../../Misc/MapWithLocation/MapWithLocation';

  
export default function EditPost({ listingID, closeEditor, refreshListings }) {
  
    const { data: session, status } = useSession();
  
    const [initialLoading, setInitialLoading] = useState(null);
    const [data, setData] = useState(null);
  
    const [policyPage, showPolicyPage] = useState(false);
  
    const [mapType, setMapType] = useState(null);
  
    function handleBack() {
        closeEditor()
        setMapType(null);
    }

    useEffect(() => {
      if(initialLoading !== null) return;
      if(data !== null) return;
      if(status === 'loading') return;
  
      const requestingUser = status === 'unauthenticated' ? 'nouser' : session.user.token.username;
  
      async function getListingData() {
          setInitialLoading(true);
  
          const apiRequest = await axios.post(`${window.location.origin}/api/auctionHub/getAuction`, {
              listingID: listingID,
              editData: true,
              requestingUser: requestingUser
          }).catch((error) => {
              errorMsg(error?.response?.data?.status || error.toString())
              closeEditor(null);
              setInitialLoading(false);
          })
  
          if(apiRequest && apiRequest.status === 200) {
            const listingData = apiRequest.data;
            setData(listingData.listing);
          }
          setInitialLoading(false);
  
      }
  
      getListingData();
  
    }, [session, status])
  
      /* Handle Listing Create Upload */
  
      const [pendingRequest, setPendingRequest] = useState(false);
  
      async function handleEditListing(data) {
          if(pendingRequest === true) return;
          if(data === null) return errorMsg("We ran into an issue creating your post, please contact us if the issue persists.");
          if(!session || status !== 'authenticated') return errorMsg("You're not authenticated to create a post, please re-login.");
  
          setPendingRequest(true);
  
          const resizeImages = await Promise.all(data.toUpload.map(async (image, index) => {
              if(image.url.includes("https://res.cloudinary.com/")) return { position: index + 1, url: image.url };
              const resized = await resizeFile(image.imageFile);
              return { position: index + 1, url: resized };
          })).catch(() => {
            errorMsg("We could not upload your image, please try again later or contact us");
            setPendingRequest(false);
            return;
          })
  
          var manipulatedData = {...data};
          manipulatedData.images = resizeImages;
          delete manipulatedData.toUpload;
  
          const apiResult = await axios.post(`${window.location.origin}/api/auctionHub/editAuctionListing`, { data: manipulatedData, requestingID: session.user.token.id }).catch((error) => { 
              errorMsg(error?.response?.data?.status || error.toString());
              setPendingRequest(false);
          });
        
          if(apiResult && apiResult.status === 200) {
              successMsg("Listing changes have been published.");
              setPendingRequest(false);
              closeEditor();
              refreshListings();
          }
  
      }
  
      /* END HANDLE LISTING UPLOAD */
  
      /* HANDLE DELETE LISTING */
  
      async function handleDeleteListing(listingID) {
          if(pendingRequest === true) return;
          if(!listingID) return errorMsg("We ran into an issue when deleting your listing, please try again later.");
          if(!session || status !== 'authenticated') return errorMsg("You're not authenticated to delete this post, please re-login.");
  
          setPendingRequest(true);
  
          const apiResult = await axios.post(`${window.location.origin}/api/auctionHub/deleteAuctionListing`, {
              userID: session.user.token.id,
              listingID: listingID
          }).catch((error) => { 
              errorMsg(error?.response?.data?.status || error.toString());
              setPendingRequest(false);
          });
        
          if(apiResult && apiResult.status === 200) {
              successMsg("This post has been deleted.");
              setPendingRequest(false);
              closeEditor();
              refreshListings();
          }
  
      }
      
      /* END HANDLE DELETE LISTING */
  
      /* Handle Image Data Here */
  
      const resizeFile = (file) =>
      new Promise((resolve, reject) => {
        Resizer.imageFileResizer(
          file,
          1500,
          1500,
          "PNG",
          100,
          0,
          (uri) => {
            resolve(uri);
          },
          "base64",
          200,
          200
        );
      });
  
      /* ==== End Handle Image Data ===== */
  
      function isLoading() {
          if(initialLoading === null || initialLoading === true) return true;
          if(data === null) return true;
          return false;
      }

      /* EDIT AUCTION DATA */


    return (
      <section id={styles.wrapper}>

          <div id={styles.container}>
  
          { policyPage === true && <section id={styles.policyContainer}> <FontAwesomeIcon onClick={() => showPolicyPage(false)} icon={faXmarkCircle} id={styles.exitPolicy} /> <PolicyPage /> </section> }
  
          { isLoading() === true && <span id={styles.loading}><PulseLoader size={30} color='#154734' /></span> }
          { isLoading() === false && 
          <>
              <div id={styles.form}>

                <EditContainer setMapType={setMapType} handleBack={handleBack} data={data} showPolicyPage={showPolicyPage} pendingRequest={pendingRequest} closeEditor={closeEditor} handleEditListing={handleEditListing} handleDeleteListing={handleDeleteListing} />

              </div>
              <div id={styles.interactiveMap}>
                  
                { (mapType !== null && mapType.type === 'ZIP' ) && <MapWithRadius zipCode={mapType.zip} /> }
                { (mapType !== null && mapType.type === 'Location' ) && <MapWithLocation address={mapType.address} city={mapType.city} zipCode={mapType.zip} /> }
                { mapType === null && <FontAwesomeIcon icon={faMapLocationDot} id={styles.icon} /> }
  
              </div>
          </>
          }
  
          </div>
      </section>
    )
  }


  const EditContainer = ({ setMapType, handleBack, data, showPolicyPage, pendingRequest, handleEditListing, handleDeleteListing }) => {

    const [uploads, setUploads] = useState(data.images.sort((a, b) => a.position - b.position));

    const [title, setTitle] = useState(data.title);
    const [itemPrice, setItemPrice] = useState(data.price);
    const [desc, setDesc] = useState(data.description);
    const [zip, setZIP] = useState(data.zip);

    const acceptPayments = data.acceptPayments?.enabled;
    const auctionDuration = data.auctionDuration;

    const [auctionDetails, setAuctionDetails] = useState(data.auctionDetails);

     // Function to add a new detail set
     const addDetailSet = () => {
          setAuctionDetails(prevDetails => [
              ...prevDetails,
              { type: '', detail: '' }
          ]);
      };

      // Function to remove a detail set
      const removeDetail = (indexToRemove) => {
          setAuctionDetails(prevDetails => prevDetails.filter((_, index) => index !== indexToRemove));
      };

      // Function to handle changes in type or detail
      const handleDetailChange = (index, field, value) => {
          setAuctionDetails(prevDetails => {
              const updatedDetails = [...prevDetails];
              updatedDetails[index] = {
                  ...updatedDetails[index],
                  [field]: value
              };
              return updatedDetails;
          });
      };


    useEffect(() => {
        if(zip.length === 5 || zip.length === 10) {
            setMapType({ type: "ZIP", zip: zip });
        } else {
            setMapType(null);
        }
    }, [zip])

    const [itemCondition, setItemCondition] = useState(data.condition);
    const [conditionMenu, showConditionMenu] = useState(false);
  
    function selectItemCondition(e, category) {
        e.preventDefault()
        if(category === itemCondition) return;
        setItemCondition(category);
        showConditionMenu(false)
    }
  
    const [itemCategory, setItemCategory] = useState(data.category);
    const [categoryMenu, showCategoryMenu] = useState(false);
  
    const changeItemCategory = (e, catID) => {
        e.preventDefault();
        if(catID === itemCategory) return;
        setItemCategory(categoryName(catID));
        showCategoryMenu(false);
    }
  
    const [meetupPref, setMeetupPref] = useState(data.meetupPref);
    const [meetupMenu, showMeetupMenu] = useState(false);
  
    function selectMeetupPreference(e, preference) {
        e.preventDefault()
        if(preference === meetupPref) return;
        setMeetupPref(preference);
        showMeetupMenu(false)
    }
  
    const priceValueCap = (inputObj) => {
        const { value } = inputObj;
        if (value <= 1000000) return true;
        return false;
    };
  
    function handleSubmit() {
      
        const listingData = {
          listingID: data._id,
          title: title,
          description: desc,
          category: itemCategory,
          condition: itemCondition,
          meetupPref: meetupPref,
          auctionDetails: auctionDetails,
          price: itemPrice,
          zip: zip,
          toUpload: uploads,
        }
        
  
        handleEditListing(listingData);
    }
  
    const [canSubmit, setCanSubmit] = useState(false);
  //        (isEqual(auctionDetails, data.auctionDetails) || auctionDetails.some(set => set.type.trim() === '' || set.detail.trim() === '')) &&
    useEffect(() => {
      if((uploads.length === 0 || isEqual(uploads, data.images.sort((a, b) => a.position - b.position))) &&
        (title.length < 5 || title.length > 50 || title === data.title) &&
        (itemPrice.length === 0 || itemPrice === data.price) &&
        (desc.length < 15 || desc === data.description) &&
        itemCondition === data.condition &&
        itemCategory === data.category &&
        meetupPref === data.meetupPref &&
        zip === data.zip || zip.length < 5) {
        setCanSubmit(false);
      } else {
        setCanSubmit(true);
      }
  
    }, [uploads, setUploads, title, itemPrice, desc, itemCondition, auctionDetails, itemCategory, meetupPref, zip])
  
    const [confirmDeletion, setConfirmDeletion] = useState(false);
  
    function incomingUploadsArray(newUploads) {
        setUploads(newUploads)
    }

    const memoizeImageGrid = useMemo(() => <GridDragAndDrop initialImages={uploads} pendingRequest={pendingRequest} receiveUploadData={incomingUploadsArray}  />, [pendingRequest])

    function handlePriceChangeCheck(val) {
        if(pendingRequest === true) return;
        if(data.bids.length > 0) return errorMsg("Starting bid can only be edited if there are no bids.");
        setItemPrice(val);
    }

    function hasAuctionEnded() {
        const durDays = parseInt(data.auctionDuration);

        const ending_date = new Date(Date.parse(data.creationDate));
        ending_date.setDate(ending_date.getDate() + durDays);
      
        const current_day = new Date();

        if(current_day >= ending_date) return true;
        return false;
    }

    return (
        <section id={styles.sellanitem}>
    
     { confirmDeletion === true && <section id={styles.confirmDeletion}>
                <div>
                    <div>
                        <h1>Confirm Deletion</h1>
                        <span>
                            <button id={styles.confirm} onClick={() => { handleDeleteListing(data._id); setConfirmDeletion(false) }}>
                                <FontAwesomeIcon icon={faCheck} id={styles.icon} />
                            </button>
                            <button id={styles.cancel} onClick={() => setConfirmDeletion(false)}>
                                <FontAwesomeIcon icon={faXmark} id={styles.icon} />
                            </button>
                        </span>
                    </div>
                </div>
            </section> }

        <section id={styles.wrapper}>

        <FontAwesomeIcon icon={faChevronLeft} id={styles.goBack} onClick={() => handleBack()} />

        <div id={styles.gridContainer}>
            <h1>{uploads.length} / 12 slots available</h1>
            {memoizeImageGrid}
        </div>

        <div id={styles.enterInfo}>
            <h1>Listing Details</h1>

            <section id={styles.title}>
                <input disabled={pendingRequest || hasAuctionEnded()} onChange={(e) => setTitle(e.target.value)} type='text' placeholder="Title" maxLength={50} defaultValue={data.title} />
                {title !== null && ( title.length < 5 && <h6>{title.length - 5}</h6> )}
            </section>

            <NumberFormat onValueChange={(values, sourceInfo) => handlePriceChangeCheck(values.value)} disabled={hasAuctionEnded() || data.bids.length > 0} isAllowed={priceValueCap} decimalSeparator={false} placeholder="Starting Bid $" thousandSeparator={true} prefix={'$'} value={itemPrice} />

            <div className={styles.dropdown}>
                <button disabled={hasAuctionEnded() || data.bids.length < 0} style={{color: 'black'}} className={styles.dropdownBtn}>Duration: {auctionDuration} Days</button>
            </div>

            <div onMouseLeave={() => showConditionMenu(false)} className={styles.dropdown}>
                <button disabled={pendingRequest || hasAuctionEnded()} style={{color: itemCondition === 'Select Condition' ? '#818181' : 'black'}} onClick={(e) => {e.preventDefault(); showConditionMenu(conditionMenu ? false : true)} } className={styles.dropdownBtn}>{itemCondition} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                <div style={{ height: 'auto', display: conditionMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                    <button onClick={(e) => selectItemCondition(e, "New")}>New</button>
                    <button onClick={(e) => selectItemCondition(e, "Good")}>Good</button>
                    <button onClick={(e) => selectItemCondition(e, "Fair")}>Fair</button>
                    <button onClick={(e) => selectItemCondition(e, "For parts or not working")}>For parts or not working</button>
                </div>
            </div>

            <div onMouseLeave={() => showCategoryMenu(false)} className={styles.dropdown}>
            <button disabled={pendingRequest || hasAuctionEnded()} style={{color: itemCategory === 'Select Category' ? '#818181' : 'black'}} onClick={ (e) => {e.preventDefault(); showCategoryMenu(categoryMenu ? false : true)} } className={styles.dropdownBtn}>{itemCategory} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                <div style={{height: '200px', display: categoryMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                    <button onClick={(e) => changeItemCategory(e, 1)}>Antiques</button>
                    <button onClick={(e) => changeItemCategory(e, 2)}>Appliances</button>
                    <button onClick={(e) => changeItemCategory(e, 3)}>Art</button>
                    <button onClick={(e) => changeItemCategory(e, 4)}>Baby & Kids</button>
                    <button onClick={(e) => changeItemCategory(e, 5)}>Books</button>
                    <button onClick={(e) => changeItemCategory(e, 28)}>Cars & Trucks</button>
                    <button onClick={(e) => changeItemCategory(e, 31)}>Cars Parts</button>
                    <button onClick={(e) => changeItemCategory(e, 6)}>Cell Phones</button>
                    <button onClick={(e) => changeItemCategory(e, 7)}>Clothing</button>
                    <button onClick={(e) => changeItemCategory(e, 8)}>Collectibles</button>
                    <button onClick={(e) => changeItemCategory(e, 9)}>Computers</button>
                    <button onClick={(e) => changeItemCategory(e, 10)}>Crafts</button>
                    <button onClick={(e) => changeItemCategory(e, 11)}>Electronics</button>
                    <button onClick={(e) => changeItemCategory(e, 12)}>Furniture</button>
                    <button onClick={(e) => changeItemCategory(e, 13)}>Games & Toys</button>
                    <button onClick={(e) => changeItemCategory(e, 14)}>Health & Beauty</button>
                    <button onClick={(e) => changeItemCategory(e, 15)}>Hobbies</button>
                    <button onClick={(e) => changeItemCategory(e, 16)}>Home & Garden</button>
                    <button onClick={(e) => changeItemCategory(e, 17)}>Jewelry</button>
                    <button onClick={(e) => changeItemCategory(e, 18)}>Kitchenware</button>
                    <button onClick={(e) => changeItemCategory(e, 32)}>Miscellaneous</button>
                    <button onClick={(e) => changeItemCategory(e, 19)}>Musical Instruments</button>
                    <button onClick={(e) => changeItemCategory(e, 20)}>Music</button>
                    <button onClick={(e) => changeItemCategory(e, 21)}>Office Supplies</button>
                    <button onClick={(e) => changeItemCategory(e, 22)}>Outdoor Gear</button>
                    <button onClick={(e) => changeItemCategory(e, 23)}>Pet Supplies</button>
                    <button onClick={(e) => changeItemCategory(e, 24)}>Photography</button>
                    <button onClick={(e) => changeItemCategory(e, 25)}>Sporting Equipment</button>
                    <button onClick={(e) => changeItemCategory(e, 26)}>Sporting Goods</button>
                    <button onClick={(e) => changeItemCategory(e, 27)}>Tools</button>
                    <button onClick={(e) => changeItemCategory(e, 29)}>Video Games</button>
                    <button onClick={(e) => changeItemCategory(e, 30)}>Vintage Items</button>
                    <button onClick={(e) => changeItemCategory(e, 33)}>Other</button>
                </div>
            </div>

            <section id={styles.addFeatures}>
                <div>
                    <h1>Specific Details</h1>
                    <FontAwesomeIcon onClick={addDetailSet} icon={faPlusCircle} id={styles.icon} />
                </div>
                <div>
                    {auctionDetails.map((set, index) => (
                        <span key={index} className={styles.detailCard}>
                            <input
                                type='text'
                                placeholder='Part#'
                                value={set.type}
                                onChange={(e) => handleDetailChange(index, 'type', e.target.value)}
                            />
                            <input
                                type='text'
                                placeholder='PN34989123'
                                value={set.detail}
                                onChange={(e) => handleDetailChange(index, 'detail', e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={faXmarkCircle}
                                id={styles.removeDetail}
                                onClick={() => removeDetail(index)}
                            />
                        </span>
                    ))}
                </div>
            </section>

            <section id={styles.desc}>
                <textarea disabled={pendingRequest || hasAuctionEnded()} onChange={(e) => setDesc(e.target.value)} placeholder="Description" maxLength={2000} defaultValue={data.description} />
                {desc !== null && ( desc.length < 15 && <h6>{desc.length - 15}</h6> )}
            </section>
            

            <div onMouseLeave={() => showMeetupMenu(false)} className={styles.dropdown}>
                <button disabled={pendingRequest || hasAuctionEnded()} style={{color: meetupPref === 'Meetup Preference' ? '#818181' : 'black'}} onClick={(e) => {e.preventDefault(); showMeetupMenu(meetupMenu ? false : true)} } className={styles.dropdownBtn}>{meetupPref} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                <div style={{ height: 'auto', display: meetupMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                    <button onClick={(e) => selectMeetupPreference(e, "Public Meetup")}>Public Meetup</button>
                    <button onClick={(e) => selectMeetupPreference(e, "Drop Off")}>Drop Off</button>
                    <button onClick={(e) => selectMeetupPreference(e, "Pickup")}>Pickup</button>
                </div>
            </div>

            <section id={styles.zip}>
                <input disabled={pendingRequest || hasAuctionEnded()} onChange={(e) => setZIP(e.target.value)} type='text' placeholder="ZIP Code" maxLength={10} defaultValue={data.zip} />
                {title !== null && ( title.length < 5 && <h6>{title.length - 5}</h6> )}
            </section>

            <ListingMap zip={zip} />

            <section id={styles.paymentContainer} style={{display: !acceptPayments ? 'none' : 'flex'}} >
                <h1>You're accepting payments <FontAwesomeIcon icon={faCheckCircle} color='green' style={{marginLeft: '4px'}} /></h1>
            </section>

            <p>Auction items are public and can be seen by anyone on or off Waco Exchange. Items like animals, drugs, weapons, counterfeits, and other items that infringe intellectual property aren't allowed on Marketplace. See our <b onClick={() => showPolicyPage(true)}>Policy Page</b> for more info.</p>
            <button style={{display: hasAuctionEnded() ? 'none' : 'flex'}} disabled={!canSubmit} onClick={handleSubmit} id={styles.createListing}>
                { pendingRequest === true ? <PulseLoader size={15} color='white' /> : <> Edit Listing <FontAwesomeIcon icon={faClipboardCheck} id={styles.icon} /> </>}
            </button>
            <button onClick={() => setConfirmDeletion(true)} id={styles.deleteListing}>
                { pendingRequest === true ? <PulseLoader size={15} color='white' /> : <> Delete Listing <FontAwesomeIcon icon={faTrashCan} id={styles.icon} /> </>}
            </button>

        </div>
        </section>

    </section>
    )
  }

  const ListingMap = ({ zip }) => {

    function isMapViewable() {
        if(zip === null || zip === undefined) return false;
        if(zip.length === 5 || zip.length === 10) return true;
        return false;
    }

    return (
        <section id={styles.listingInteractiveMap}>
            { isMapViewable() && <MapWithRadius zipCode={zip} /> }
            { !isMapViewable() && <FontAwesomeIcon icon={faMapLocationDot} id={styles.icon} /> }
        </section>
    )
}